import React from 'react';

import {
  StyledInputSwitch,
  StyledSwitchContainer,
  StyledThumb,
  StyledTrack
} from './styles';

export interface SwitchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  /**
   * The size of the switch. `small` is equivalent to the dense switch styling.
   */
  size?: 'small' | 'normal';
  /**
   * If given, uses a negative margin to counteract
   * the padding on one side (this is often helpful
   * for aligning the left or right side of the icon
   * with content above or below, without ruining the
   * border size and shape).
   */
  edge?: 'end' | 'start' | false;
}

const Switch: React.FC<SwitchProps> = React.forwardRef<
  HTMLInputElement,
  SwitchProps
>(({ size = 'normal', edge = false, ...props }, ref) => {
  return (
    <StyledSwitchContainer size={size} edge={edge}>
      <StyledInputSwitch {...props} ref={ref} type="checkbox" />
      <StyledThumb />
      <StyledTrack />
    </StyledSwitchContainer>
  );
});

export default Switch;
